define((require) => {
    "use strict";

    const ImprovedView        = require("zbone/ImprovedView.js");
    const template            = require("ui/experience/widgets/button/IconPropertiesView.tpl");
    const ButtonIconModel     = require("shared/ui/experience/widgets/button/ButtonIconModel");
    const ColorPicker         = require("shared/services/ColorPicker");
    const IconsSelectionView  = require("ui/experience/widgets/button/IconsSelectionView");

    return ImprovedView.extend("IconPropertiesView", {

        className: "icon-properties",

        template,

        templateHelpers() {
            return {
                Placement: ButtonIconModel.Placement
            };
        },

        regions: {
            iconsSelectionRegion: ".icons-selection-region"
        },

        ui: {
            iconCheckbox: ".icon-checkbox",
            contentContainer: ".content-container",
            iconColorInput: ".button-icon-color-input",
            iconColorBox: ".icon-color-box",
            placementSelect: ".placement-select"
        },

        modelEvents: {
            "change:icon": "_iconChangeHandler"
        },

        events: {
            "click @ui.iconCheckbox": "_iconCheckboxClickHandler"
        },

        iconBindings: {
            ".placement-select": "placement",
            ".button-icon-color-input": {
                observe: "color",
                onSet(color) {
                    return this._iconColorPicker.hexOrDefault(color);
                }
            }
        },

        onRender() {
            this.stickit(this.model.get("icon"), this.iconBindings);

            const iconColor = this.model.get("icon").get("color");

            this._iconColorPicker = new ColorPicker({
                color: iconColor,
                input: this.ui.iconColorInput,
                colorBox: this.ui.iconColorBox,
                includeTransparency: false
            });
        },

        onShow() {
            this.iconsSelectionRegion.show(new IconsSelectionView({model: this.model}));
        },

        onClose() {
            this._iconColorPicker.dispose();
        },

        hide() {
            this.$el.addClass("hidden");
        },

        unhide() {
            this.$el.removeClass("hidden");
        },

        hideIconPositionSelect() {
            this.ui.placementSelect.addClass("hidden");
        },

        unhideIconPositionSelect() {
            this.ui.placementSelect.removeClass("hidden");
        },

        _iconChangeHandler(model, icon) {
            if (!(icon instanceof ButtonIconModel)) {
                return;
            }

            // the previous icon bindings have to be unstuck and the new icon's bindings have to be stuck for the icon color picker.
            const previousIcon = model.previous("icon");

            if (previousIcon) {
                this.unstickit(previousIcon);
            }

            if (icon) {
                this.stickit(icon, this.iconBindings);
            }

            this.iconsSelectionRegion.currentView.updateSelectedIcon(icon);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/IconPropertiesView.js